define("shared/utils/fp/result", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.ok = _exports.isOk = _exports.isError = _exports.error = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  /**
   * Result type - represents a value that can be Left (error) or Right (success)
   */

  const error = error => ({
    _tag: 'Error',
    error
  });
  _exports.error = error;
  const ok = value => ({
    _tag: 'Ok',
    value
  });
  _exports.ok = ok;
  const isError = result => result._tag === 'Error';
  _exports.isError = isError;
  const isOk = result => result._tag === 'Ok';
  _exports.isOk = isOk;
});